import { useRef, useState, useEffect, useCallback } from "react";

const useScrollOverflowDetection = () => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const checkScrollPosition = useCallback(() => {
    const element = scrollContainerRef.current;
    if (!element) return;

    const { scrollTop, scrollHeight, clientHeight } = element;
    const threshold = 1;

    setCanScrollUp(scrollTop > threshold);
    setCanScrollDown(scrollTop < scrollHeight - clientHeight - threshold);
  }, []);

  useEffect(() => {
    const element = scrollContainerRef.current;
    if (!element) return;

    const timeoutId = setTimeout(checkScrollPosition, 0);

    element.addEventListener("scroll", checkScrollPosition, { passive: true });

    const resizeObserver = new ResizeObserver(checkScrollPosition);
    resizeObserver.observe(element);

    return () => {
      clearTimeout(timeoutId);
      element.removeEventListener("scroll", checkScrollPosition);
      resizeObserver.disconnect();
    };
  }, [checkScrollPosition]);

  return {
    scrollContainerRef,
    canScrollUp,
    canScrollDown,
    checkScrollPosition,
  };
};

export default useScrollOverflowDetection;
